/* eslint-disable no-sequences */
import React, { useEffect, useState } from "react";
import { useMutation } from "react-query";
import { useNavigate, useLocation } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import {
	onlineAccountInfo,
	findMemberByMobileNumber,
	onlineCollection,
	addMomoPayment,
	getPaymentLedger,
} from "../../../api/apiServices";
import generateTransactionId from "../../../services/generateTransactionId";
import Loader from "../../Common/Spinner/Loader";
import getServiceProvider from "../../../services/getServiceProvider";

const languageId = `${process.env.REACT_APP_LANGUAGE_ID}`;
const countryCode = `${process.env.REACT_APP_COUNTRY_CODE}`;
const transCurrencyIso = `${process.env.REACT_APP_TRANS_CURRENCY_ISO}`;

const DuesPayment = () => {
	const [isLoading, setIsLoading] = useState(false);
	const navigate = useNavigate();
	const location = useLocation();
	const from = location.state?.from?.pathname || "/";

	let curr = new Date();
	curr.setDate(curr.getDate());
	let date = curr.toISOString().substring(0, 10);

	const [isMoMo, setIsMoMo] = useState(false);
	const [isMakePayment, setIsMakePayment] = useState(false);
	const [member_ledger, setMemberLedger] = useState([]);
	const [findMember, setFindMember] = useState(false);

	const [payment_year, setPaymentYear] = useState("");
	const [payment_type, setPaymentType] = useState("MP");
	const [payment_mode, setPaymentMode] = useState("");
	const [pf_number, setPFNumber] = useState("");
	const [mobile_number, setMobileNumber] = useState("");
	const [fullname, setFullname] = useState();
	const [amount, setAmount] = useState("");
	const [payPartnerServiceId, setPayPartnerServiceId] = useState("");
	const [transaction_id, setTransactionId] = useState("");

	const [isPayWithAnotherNumber, setIsPayWithAnotherNumber] = useState(false);
	const [pay_with_another_number, setPayWithAnotherNumber] = useState("");

	const [another_phone_number, setAnotherPhoneNumber] = useState("");
	const [anotherPhoneNumberFullname, setAnotherPhoneNumberFullname] =
		useState("");

	const year = 2024;
	const years = Array.from(new Array(20), (val, index) => index + year);

	useEffect(() => {
		pf_number &&
			getPaymentLedger(pf_number).then((res) => {
				setMemberLedger(res);
			});
	}, [pf_number]);

	const handleSearchMember = () => {
		mobile_number &&
			findMemberByMobileNumber(mobile_number).then((res) => {
				setPFNumber(res.member?.pf_number);
				setFullname(
					res?.member?.first_name +
						" " +
						res?.member?.middle_name +
						" " +
						res?.member?.last_name
				);
				setFindMember(true);
			});
		generateTransactionId().then((result) => {
			setTransactionId(result);
		});
	};

	let transactionDate = [];
	let transactionYear = [];
	for (var i = 0; i < member_ledger?.length; i++) {
		transactionDate.push(new Date([member_ledger[i].transaction_date]));
		transactionYear.push(member_ledger[i].year);
	}

	transactionDate.sort((a, b) => a - b);
	transactionYear.sort((a, b) => a - b);

	let maxTDate = transactionDate[transactionDate.length - 1];
	let maxYear = transactionYear[transactionYear.length - 1];

	// console.log("Max date:", maxTDate.toISOString().split('T')[0]);
	const lastYear = member_ledger?.filter(
		(item) =>
			new Date(item.transaction_date).toISOString().split("T")[0] ===
			maxTDate.toISOString().split("T")[0]
	);

	let maxClosingBalance = Math.max(lastYear[0]?.closing_balance);

	const handleMobileNumberInput = (value, countryObj, e, formattedValue) => {
		const name = e.target.name;

		let mobileNumber = value.replaceAll(" ", "");

		if (mobileNumber.substring(4, 0) === "2330") {
			mobileNumber = mobileNumber.replace("0", "");
		}

		if (name === "another_phone_number") {
			setAnotherPhoneNumber(mobileNumber);
		} else {
			setMobileNumber(mobileNumber.replaceAll(" ", ""));
		}
	};

	const handlePayWithAnotherNumber = (e) => {
		const anotherNumber = e.target.value;
		setPayWithAnotherNumber(anotherNumber);
		if (anotherNumber === "YES") {
			setIsPayWithAnotherNumber(true);
			setPaymentMode("M");
			setIsMoMo(true);
		} else {
			getServiceProvider(mobile_number).then((result) => {
				setPayPartnerServiceId(result);
			});
			setIsPayWithAnotherNumber(false);
			setPaymentMode("M");
			setIsMoMo(true);
		}
	};

	const handleAccountInfo = async (e) => {
		const value = e.target.value.replaceAll(" ", "");
		let mobileNumber = "";
		if (value === "") {
			toast.error("Please enter your mobile number", {
				duration: 5000,
				className: "toast-message",
			});
			return false;
		} else if (value === "+233") {
			toast.error(
				"The mobile number is not valid. Please provide a valid mobile number to continue",
				{
					duration: 5000,
					className: "toast-message",
				}
			);
			return false;
		}

		if (value.substring(5, 0) === "+2330") {
			mobileNumber = value.replace("0", "");
		} else {
			mobileNumber = value;
		}
		mobileNumber = mobileNumber.replace("+", "");

		let serviceProvider = "";
		await getServiceProvider(mobileNumber).then((result) => {
			serviceProvider = result;
			// setPayPartnerServiceId(result);
		});
		const infoData = {
			CustomerAcctNo: mobileNumber,
			PayPartnerServiceId: serviceProvider,
			LanguageId: languageId,
			CountryCode: countryCode,
		};
		getMemberInfoMutation.mutate(infoData);
	};

	const getMemberInfoMutation = useMutation(onlineAccountInfo, {
		onSuccess: async (res) => {
			if (res.data.Status === false && res.status === 201) {
				toast.error(res.data.Message, {
					duration: 5000,
					className: "toast-message",
				});
				return false;
			}
			if (res.data.Status === false && res.status === 200) {
				toast.error(res.data.Message, {
					duration: 5000,
					className: "toast-message",
				});
				return false;
			}
			if (res.data.Status === true) {
				generateTransactionId().then((result) => {
					setTransactionId(result);
				});
				if (!isPayWithAnotherNumber) {
					setFullname(res.data.AccountName);
					return true;
				} else {
					setAnotherPhoneNumberFullname(res.data.AccountName);
					return true;
				}
			}
		},
		onError: async (err) => {
			toast.error(err.message, {
				duration: 5000,
				className: "toast-message",
			});
			return false;
		},
	});

	const handleOnlinePayment = (e) => {
		e.preventDefault();
		setIsLoading(true);

		const momoPaymentData = {
			PayPartnerServiceId: payPartnerServiceId,
			Amount: amount,
			AccountNoOrCardNoOrMSISDN: !isPayWithAnotherNumber
				? mobile_number
				: another_phone_number,
			AccountName: fullname.toLocaleUpperCase(),
			TransactionId: transaction_id,
			LanguageId: languageId,
			Narration: "PF Payment",
			TransCurrencyIso: transCurrencyIso,
			ExpiryDateMonth: 0,
			ExpiryDateYear: 0,
			Cvv: 0,
		};
		onlineCollectionMutation.mutate(momoPaymentData);
	};

	const onlineCollectionMutation = useMutation(onlineCollection, {
		onSuccess: async (res) => {
			if (res.data.Status === true) {
				const momoPaymentData = {
					PayPartnerServiceId: payPartnerServiceId,
					amount: parseFloat(amount).toFixed(2),
					mobile_number: mobile_number,
					fullname: fullname.toLocaleUpperCase(),
					payment_year: payment_year,
					payment_type: payment_type.toLocaleUpperCase(),
					payment_mode: payment_mode.toLocaleUpperCase(),
					pf_number: pf_number.toLocaleUpperCase(),
					transaction_id: transaction_id,
				};
				addMomoMutation.mutate(momoPaymentData);
			} else {
				toast.error(res.data.message, {
					duration: 5000,
					className: "toast-message",
				});
				setIsLoading(false);

				setIsMoMo(false);

				navigate(from, { replace: true });
			}
		},
		onError: async (err) => {
			toast.error(err.message, {
				duration: 5000,
				className: "toast-message",
			});
			setIsLoading(false);

			setIsMoMo(false);

			navigate(from, { replace: true });
		},
	});

	const addMomoMutation = useMutation(addMomoPayment, {
		onSuccess: async (res) => {
			if (res.success === true) {
				toast.success(res.message, {
					duration: 5000,
					className: "toast-message",
				});
				setIsLoading(false);

				setIsMoMo(false);

				setPaymentYear("");
				setPaymentType("");
				setPFNumber("");
				setMobileNumber("");
				setFullname("");
				setAmount("");
				setIsMakePayment(false);
			} else {
				toast.success(res.message, {
					duration: 5000,
					className: "toast-message",
				});
				setIsLoading(false);

				setIsMoMo(false);

				setPaymentYear("");
				setPaymentType("");
				setPFNumber("");
				setMobileNumber("");
				setFullname("");
				setAmount("");
				navigate(from, { replace: true });
			}
		},
		onError: async (err) => {
			toast.error(err.message, {
				duration: 5000,
				className: "toast-message",
			});
			setIsLoading(false);

			setIsMoMo(false);

			setPaymentYear("");
			setPaymentType("");
			setPFNumber("");
			setMobileNumber("");
			setFullname("");
			setAmount("");
			navigate(from, { replace: true });
		},
	});

	const handleCancel = () => {
		setIsMakePayment(false);
	};

	const handleMakePayment = (year, balance) => {
		setPaymentYear(year);
		setAmount(balance * -1);
		setIsMakePayment(true);
	};

	const memberLedger = (
		<>
			<legend>UNPAID DUES</legend>
			<div className="table-responsive lg">
				<table className="table table-borderless table-hover table-striped">
					<thead>
						<tr>
							<th style={{ textAlign: "center" }}>Year</th>
							<th style={{ textAlign: "right" }}>
								Opening Balance
							</th>
							<th style={{ textAlign: "right" }}>
								Expected Payment
							</th>
							<th style={{ textAlign: "right" }}>Amount Paid</th>
							<th style={{ textAlign: "right" }}>
								Closing Balance{" "}
							</th>
							<th style={{ textAlign: "center" }}>Action </th>
						</tr>
					</thead>
					<tbody>
						{member_ledger.map((ledger) => (
							<>
								<tr key={ledger?.id}>
									<td style={{ textAlign: "center" }}>
										{ledger?.year}
									</td>
									{ledger?.opening_balance < 0 ? (
										<td style={{ textAlign: "right" }}>
											(
											{(
												ledger?.opening_balance * -1
											).toLocaleString(undefined, {
												minimumFractionDigits: 2,
											})}
											){" "}
										</td>
									) : (
										<td style={{ textAlign: "right" }}>
											{ledger?.opening_balance.toLocaleString(
												undefined,
												{ minimumFractionDigits: 2 }
											)}{" "}
										</td>
									)}
									{ledger?.expected_total_amount < 0 ? (
										<td style={{ textAlign: "right" }}>
											(
											{(
												ledger?.expected_total_amount *
												-1
											).toLocaleString(undefined, {
												minimumFractionDigits: 2,
											})}
											){" "}
										</td>
									) : (
										<td style={{ textAlign: "right" }}>
											{ledger?.expected_total_amount.toLocaleString(
												undefined,
												{ minimumFractionDigits: 2 }
											)}{" "}
										</td>
									)}
									<td style={{ textAlign: "right" }}>
										{ledger?.total_amount_paid.toLocaleString(
											undefined,
											{ minimumFractionDigits: 2 }
										)}{" "}
									</td>
									{ledger?.closing_balance < 0 ? (
										<td style={{ textAlign: "right" }}>
											(
											{(
												ledger?.closing_balance * -1
											).toLocaleString(undefined, {
												minimumFractionDigits: 2,
											})}
											){" "}
										</td>
									) : (
										<td style={{ textAlign: "right" }}>
											{ledger?.closing_balance.toLocaleString(
												undefined,
												{ minimumFractionDigits: 2 }
											)}{" "}
										</td>
									)}
									{ledger?.closing_balance < 0 &&
									ledger?.year === maxYear ? (
										<td
											style={{
												whiteSpace: "nowrap",
												textAlign: "center",
											}}
										>
											<button
												type="button"
												style={{
													fontSize: "16px",
													padding: "5px 10px",
													borderRadius: "5px",
													backgroundColor: "brown",
													color: "#fff",
													fontWeight: "bold",
												}}
												onClick={() =>
													handleMakePayment(
														ledger?.year,
														ledger.closing_balance
													)
												}
												className="btn "
											>
												<i className="fa fa-money"></i>{" "}
												Make Payment
											</button>
										</td>
									) : (
										<td
											style={{
												whiteSpace: "nowrap",
												textAlign: "center",
												fontSize: "16px",
												padding: "5px 10px",
												borderRadius: "5px",
												// backgroundColor: "#f8312f",
												color: "green",
												fontWeight: "bold",
											}}
										>
											Payment Not Allow
										</td>
									)}
								</tr>
							</>
						))}
					</tbody>
					<tfoot>
						<tr>
							{maxClosingBalance < 0 ? (
								<td
									colSpan="7"
									style={{
										width: "55%",
										textAlign: "center",
										fontSize: "18px",
										fontWeight: "700",
										color: "darkred",
									}}
								>
									Click on "Make Payment" to pay for your dues
									and arrears. Thank you
								</td>
							) : (
								<td
									colSpan="7"
									style={{
										width: "55%",
										textAlign: "center",
										fontSize: "18px",
										fontWeight: "700",
										color: "var(--main-color)",
									}}
								>
									No dues or arrears to pay. Thank you
								</td>
							)}
						</tr>
					</tfoot>
				</table>
			</div>
		</>
	);

	const mobileMoneyPayment = (
		<>
			{!isPayWithAnotherNumber ? (
				<>
					<label htmlFor="amount" className="col-sm-5 col-form-label">
						Amount<span>&nbsp;&nbsp;*</span>
					</label>
					<div className="col-sm-7">
						<input
							type="number"
							name="amount"
							id="amount"
							style={{
								height: "40px",
								textTransform: "uppercase",
							}}
							placeholder="Amount"
							required
							value={amount}
							onChange={(e) => setAmount(e.target.value)}
							className="form-control"
						/>
						<span>An additional fee may apply to this payment</span>
					</div>
				</>
			) : (
				<>
					<label htmlFor="another_phone_number" className="col-sm-5">
						Enter Phone Number<span>&nbsp;&nbsp;*</span>
					</label>
					<div className="col-sm-7">
						<PhoneInput
							id="another_phone_number"
							inputStyle={{
								paddingTop: 16,
								paddingRight: 14,
								paddingBottom: 15,
								paddingLeft: 58,
								fontSize: 16,
								width: "100%",
								zIndex: 1,
								height: 40,
								backgroundColor: "#F3F6F9",
							}}
							country={"gh"}
							countryCodeEditable={false}
							enableSearch={true}
							value={another_phone_number}
							inputProps={{
								name: "another_phone_number",
								required: true,
								autoFocus: false,
							}}
							onChange={(value, countryObj, e, formattedValue) =>
								handleMobileNumberInput(
									value,
									countryObj,
									e,
									formattedValue
								)
							}
							onBlur={handleAccountInfo}
						/>
					</div>
					<label
						htmlFor="anotherPhoneNumberFullname"
						className="col-sm-5 col-form-label"
					>
						Full Name (From Telco)<span>&nbsp;&nbsp;*</span>
					</label>
					<div className="col-sm-7">
						<input
							type="text"
							name="anotherPhoneNumberFullname"
							id="anotherPhoneNumberFullname"
							style={{
								height: "40px",
								fontWeight: "bold",
								textTransform: "uppercase",
							}}
							required
							disabled
							autoComplete="off"
							value={anotherPhoneNumberFullname}
							onChange={(e) =>
								setAnotherPhoneNumberFullname(e.target.value)
							}
							className="form-control"
						/>
					</div>
					<label htmlFor="amount" className="col-sm-5 col-form-label">
						Amount<span>&nbsp;&nbsp;*</span>
					</label>
					<div className="col-sm-7">
						<input
							type="number"
							name="amount"
							id="amount"
							style={{
								height: "40px",
								textTransform: "uppercase",
							}}
							placeholder="Amount"
							required
							value={amount}
							onChange={(e) => setAmount(e.target.value)}
							className="form-control"
						/>
						<span>An additional fee may apply to this payment</span>
					</div>
				</>
			)}
		</>
	);

	const searchMobileNumber = (
		<>
			<fieldset className="col-sm-12">
				<div className="wrapper-container">
					<div className="form-group row">
						<label htmlFor="mobile_number" className="col-sm-3">
							Registered PF Phone Number
							<span>&nbsp;&nbsp;*</span>
						</label>
						<div className="col-sm-5">
							<PhoneInput
								id="mobile_number"
								inputStyle={{
									paddingTop: 16,
									paddingRight: 14,
									paddingBottom: 15,
									paddingLeft: 58,
									fontSize: 16,
									width: "100%",
									zIndex: 1,
									height: 40,
									backgroundColor: "#F3F6F9",
								}}
								country={"gh"}
								countryCodeEditable={false}
								enableSearch={true}
								enableClickOutside={false}
								disableDropdown={false}
								value={mobile_number}
								inputProps={{
									name: "mobile_number",
									required: true,
									autoFocus: true,
								}}
								onChange={(
									value,
									countryObj,
									e,
									formattedValue
								) =>
									handleMobileNumberInput(
										value,
										countryObj,
										e,
										formattedValue
									)
								}
								// onBlur={handlePFMembership}
							/>
						</div>
						<div className="col-sm-2">
							<button
								type="button"
								onClick={handleSearchMember}
								className="btn btn-success btn-block"
							>
								Search
							</button>
							&nbsp;&nbsp;&nbsp;&nbsp;
						</div>

						<div className="col-sm-2">
							<button
								type="button"
								onClick={handleCancel}
								className="btn btn-danger btn-block"
							>
								Cancel
							</button>
						</div>
					</div>
				</div>
			</fieldset>
		</>
	);

	let paymentForm;
	if (isLoading) {
		paymentForm = (
			<div className="loader">
				<p>Processing payment. Please wait...</p>
				<Loader />
			</div>
		);
	} else {
		paymentForm = (
			<form onSubmit={handleOnlinePayment}>
				<div className="form-group row">
					<fieldset className="col-sm-12">
						<fieldset className="col-sm-4"></fieldset>
					</fieldset>
				</div>
				<div className="form-group row">
					<fieldset className="col-sm-12">
						<legend>Regular Payment</legend>
						<fieldset className="col-sm-6">
							<label
								htmlFor="mobile_number"
								className="col-sm-5 col-form-label"
							>
								Registered Phone Number
								<span>&nbsp;&nbsp;*</span>
							</label>
							<div className="col-sm-7">
								<PhoneInput
									id="mobile_number"
									inputStyle={{
										paddingTop: 16,
										paddingRight: 14,
										paddingBottom: 15,
										paddingLeft: 58,
										fontSize: 18,
										width: "100%",
										zIndex: 1,
										height: 40,
										backgroundColor: "#F3F6F9",
									}}
									country={"gh"}
									countryCodeEditable={false}
									enableSearch={true}
									enableClickOutside={false}
									disableDropdown={false}
									value={mobile_number}
									inputProps={{
										name: "mobile_number",
										required: true,
										autoFocus: false,
									}}
									disabled
								/>
							</div>
							<label
								htmlFor="payment_type"
								className="col-sm-5 col-form-label"
							>
								Select Payment Type<span>&nbsp;&nbsp;*</span>
							</label>
							<div className="col-sm-7">
								<input
									type="text"
									name="payment_type"
									id="payment_type"
									style={{
										textTransform: "uppercase",
									}}
									value={payment_type}
									onChange={(e) =>
										setPaymentType(e.target.value)
									}
									disabled
									required
									className="form-control"
								/>
							</div>
							<label
								htmlFor="pay_with_another_number"
								className="col-sm-5 col-form-label"
							>
								Pay With Another Number?
								<span>&nbsp;&nbsp;*</span>
							</label>

							<div className="col-sm-3">
								<label htmlFor="mtn_option">
									<input
										type="checkbox"
										id="mtn_option"
										name="pay_with_another_number"
										checked={
											pay_with_another_number === "NO"
										}
										value={"NO"}
										onChange={handlePayWithAnotherNumber}
									/>
								</label>
								NO
							</div>

							<div className="col-sm-3">
								<label htmlFor="pay_with_another_number">
									<input
										type="checkbox"
										id="voda_option"
										name="pay_with_another_number"
										checked={
											pay_with_another_number === "YES"
										}
										value={"YES"}
										onChange={handlePayWithAnotherNumber}
									/>
								</label>
								YES
							</div>
							{isMoMo && mobileMoneyPayment}
						</fieldset>
					</fieldset>
				</div>
				<div className="panel-footer">
					<div className="row">
						<div className="col-sm-2">
							<button
								type="submit"
								className="btn btn-success btn-block"
							>
								Submit
							</button>
							&nbsp;&nbsp;&nbsp;&nbsp;
						</div>
						<div className="col-sm-2">
							<button
								type="button"
								onClick={handleCancel}
								className="btn btn-danger btn-block"
							>
								Cancel
							</button>
						</div>
					</div>
				</div>
			</form>
		);
	}

	return (
		<>
			<Toaster toastOptions={{ position: "top-center" }} />
			<section className="content-header">
				<h1>
					<i className="fas fa-bank"></i> Dues Payments
				</h1>
			</section>
			<section className="content">
				<div className="box">
					<div className="box-body">
						<div className="panel panel-default panel-br-4">
							<div className="panel-heading">
								<div className="row">
									<div className="col-sm-12">
										<h4 className="panel-title">
											<span></span>
										</h4>
									</div>
								</div>
							</div>
							<div className="panel-body">
								{searchMobileNumber}
							</div>
							{findMember && (
								<div className="panel-body">
									{memberLedger}
									{paymentForm}
								</div>
							)}
						</div>
					</div>
				</div>
			</section>
		</>
	);
};

export default DuesPayment;
